// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../procollege/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../procollege/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-row-warning{background-color:#fff5e0}`, "",{"version":3,"sources":["webpack://./../blocks/manage_groups/secretariat/students/components/studentsList.vue"],"names":[],"mappings":"AACA,qBACE,wBAAA","sourcesContent":["\r\n.student-row-warning {\r\n  background-color: #fff5e0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
